import useSWR from "swr";
import type { SwrReturnType } from "~/models/Api";
import type { OwnerExplanationSuggestionExecutable } from "~/models/OwnerExplanationSuggestion";
import { generatePath } from "~/utils/generatePath";

export const useOwnerExplanationSuggestionExecutable = (
	dealId: number
): SwrReturnType<OwnerExplanationSuggestionExecutable> => {
	const { data, mutate, error, isLoading } =
		useSWR<OwnerExplanationSuggestionExecutable>(
			generatePath("/deals/:deal_id/owner_explanation_suggestion/executable", {
				deal_id: dealId
			})
		);

	return {
		data: data ?? null,
		error,
		isLoading,
		mutate
	};
};
